import React from 'react';
import { injectIntl} from 'react-intl';

import ActionLink from '../builder/ActionLink';

const XeerpaDiscovery = (props) => {
	return (
	<div>
		<ActionLink onClick={props.close}>Close</ActionLink>
		<div dangerouslySetInnerHTML={{ __html:(props.data) }}></div>
	</div>
	
	);
}

export default injectIntl(XeerpaDiscovery);